
const SlideContent = require('./SlideContent')
/**
 * 代表一整份幻燈片的內容
 */
class SlidePage{
  /**
   * @param {SlidePage} opts
   */
  constructor(opts = {}){
    this.id = opts.id
    /**
     * @type {SlideContent[]}
     */
    this.contents = opts.contents || []
    this.contents = this.contents.map((content)=>{
      return new SlideContent(content)
    })
  }
  /**
   * @typedef {Object} SearchResult
   * @property {SlideContent} content
   * @property {String} keyword
   * @property {Number} contentIndex
   * @property {Number} keywordIndex
   */
  /**
   * @param {string} query
   * @param {{limit: Number}} opts
   * @returns {SearchResult[]}
   */
  searchContent(query, opts = {}){
    if(typeof query === 'string' && query.length > 0){
      let limit = opts.limit || 1
      if(limit <= 0){
        limit = 1
      }
      let results = []
      for(let contentIndex in this.contents){
        let content = this.contents[contentIndex]
        for(let keywordIndex in content.keywords){
          let keyword = content.keywords[keywordIndex]
          if(query.indexOf(keyword) > -1){
            results.push({
              content,
              keyword,
              contentIndex,
              keywordIndex
            })
            if(results.length >= limit){
              return results
            }
          }
        }
      }
    }else{
      return []
    }
  }
}
module.exports = SlidePage
